module.exports = __webpack_public_path__ + "media/images/index-hero-badge-zh-MY-cdb58a5115e4e96b77ae8e124eb7cca1.svg";